<template>
    <div class="home">
        <el-container class="home-container">
            <!--            左边侧边-->
            <el-aside :width="isCollapse?minWidth:maxWidth">
                <div class="home-logo">
                    <el-menu background-color="#3f4d67"
                             text-color="#fff"
                             router>
                        <el-menu-item :index=" '/home'">
                            <!--                        logo-->
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none"
                                 stroke="currentColor"
                                 stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                 class="d-block mx-auto"
                                 role="img" viewBox="0 0 24 24" focusable="false"><title>
                                {{this.$store.state.webName}}</title>
                                <circle cx="12" cy="12" r="10"/>
                                <path d="M14.31 8l5.74 9.94M9.69 8h11.48M7.38 12l5.74-9.94M9.69 16L3.95 6.06M14.31 16H2.83m13.79-4l-5.74 9.94"/>
                            </svg>
                            <!--                        logo-->
                            <span class="logo-text"
                                  :class="isCollapse?'margin-left':''">{{this.$store.state.webName}}</span>
                        </el-menu-item>
                    </el-menu>
                </div>

                <el-menu
                        :default-active="$route.path"
                        :collapse="isCollapse"
                        router
                        unique-opened
                        @select="handleSelect"
                        background-color="#3d4e63"
                        text-color="#fff"
                        active-text-color="#1dc4e9">
                    <template v-for="(item,index) in menuList">
                        <el-menu-item :index=" '/' + item.path" v-if="item.children.length == 0">
                            <i :class="item.icon"></i>
                            <span slot="title">{{item.name}}</span>
                        </el-menu-item>
                        <el-submenu :index="index + '' " v-else>
                            <template slot="title" :index=" '/' + item.path">
                                <i :class="item.icon"/>
                                <span>{{item.name}}</span>
                            </template>
                            <el-menu-item v-if="item.children" :index=" '/' + secondary.path"
                                          v-for="(secondary,index) in item.children"
                                          :key="index">
                                <template slot="title">
                                    <i class="el-icon-menu"/>
                                    <span>{{secondary.name}}</span>
                                </template>
                            </el-menu-item>
                        </el-submenu>
                    </template>
                </el-menu>
            </el-aside>
            <div class="mark" v-show="markSHow" @click="isCollapses"></div>
            <!--            左边侧边 end-->
            <el-container>
                <!--                头部区域-->
                <el-header>
                    <div>
                        <!--                    开关侧边栏-->
                        <i :class=" isCollapse?'el-icon-s-unfold':'el-icon-s-fold'"
                           class="isCollapse-icon" @click="isCollapses"></i>
                    </div>
                    <div>
                        <el-dropdown trigger="click" @command="handleCommand">
                            <el-avatar
                                    src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="a">个人信息</el-dropdown-item>
                                <el-dropdown-item command="b">修改密码</el-dropdown-item>
                                <el-dropdown-item command="c">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </el-header>
                <!--                头部区域end-->
                <!--                主体区域-->
                <el-main>
                    <router-view/>
                </el-main>
                <!--                主体end-->
            </el-container>
        </el-container>
        <el-dialog
                title="个人信息"
                :visible.sync="dialogVisibleuser"
                width="50%">
            <el-row :gutter="30">
                <el-col :span="10">
                    <el-form ref="form" label-width="100px" size="small">
                        <el-form-item label="名称">
                            <el-input v-model="homeform.title"></el-input>
                        </el-form-item>
                        <el-form-item label="用户名">
                            <el-input v-model="homeform.username"></el-input>
                        </el-form-item>
                        <el-form-item label="密码">
                            <el-input v-model="homeform.tpassword"></el-input>
                        </el-form-item>
                        <el-form-item label="QQ">
                            <el-input v-model="homeform.qq"></el-input>
                        </el-form-item>
                        <el-form-item label="微信">
                            <el-input v-model="homeform.weixin"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号">
                            <el-input v-model="homeform.phone"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="10">
                    <el-form ref="form" label-width="100px" size="small">
                        <el-form-item label="渠道码">
                            <img :src="homeform.qrcode" class="avatar" alt="">
                        </el-form-item>
                        <el-form-item label="渠道链接">
                            <el-input v-model="homeform.qrcode_url"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="copyLInk" id="copyLInk"
                                       :data-clipboard-text="homeform.qrcode_url">复制
                            </el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </el-dialog>
        <el-dialog
                title="修改密码"
                :visible.sync="dialogVisiblepas"
                width="50%">
            <el-row :gutter="20">
                <el-col :span="15">
                    <el-form ref="form" label-width="200px" size="small">
                        <el-form-item label="旧密码">
                            <el-input v-model="pasform.password"></el-input>
                        </el-form-item>
                        <el-form-item label="新密码">
                            <el-input v-model="pasform.new_password"></el-input>
                        </el-form-item>
                        <el-form-item label="确认新密码">
                            <el-input v-model="pasform.repeat_password"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisiblepas = false" size="small">取 消</el-button>
    <el-button type="primary" @click="updatePas" size="small">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
  import Clipboard from 'clipboard';

  export default {
    name: 'Home',
    metaInfo() {
      return {
        title: this.$store.state.webName, // system-set a title
      }
    },
    data() {
      return {
        isCollapse: false,
        homeform: {
          avatar: '',
          username: '',
          phone: '',
        },
        pasform: {
          password: '',
          new_password: '',
          repeat_password: ''
        },
        dialogVisibleuser: false,
        dialogVisiblepas: false,
        menuList: [],
        minWidth: '60px',
        maxWidth: '270px',
        windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
        markSHow: false,
      }
    },
    watch: {
      '$route'() {
        this.handleSelect(this.activeIndex)
      },
      windowWidth(val) {
        this.windowWidth = val;
        if (this.windowWidth <= 750) {
          this.minWidth = '0px';
          this.maxWidth = '180px';
          this.isCollapse = true;
        } else {
          this.minWidth = '60px';
          this.maxWidth = '270px';
          this.isCollapse = false;
        }
        this.judge();
      }
    },
    created() {
      let activeIndex = sessionStorage.getItem('activeIndex');
      if (activeIndex) {
        this.activeIndex = activeIndex;
      }
      this.getUserInfo();
      this.getWebName();
      if (this.windowWidth <= 750) {
        this.minWidth = '0px';
        this.maxWidth = '75%';
        this.isCollapse = true;
      }
      this.judge();
    },
    methods: {
      // 侧边开关
      judge() {
        if (this.windowWidth <= 750) {
          this.$store.dispatch('getNewDialogWidth', '90%');
          this.$store.dispatch('getNewLabelWidth', '100px');
          this.$store.dispatch('getNewPaginationLayout', 'total, sizes, prev, next');
          this.$store.dispatch('getNewElColNum', 24);
          this.$store.dispatch('getNewDialogMaxWidth', '90%');
          this.$store.dispatch('getNewSetLabelWidth', '100px');
        } else {
          this.$store.dispatch('getNewDialogWidth', '50%');
          this.$store.dispatch('getNewLabelWidth', '200px');
          this.$store.dispatch('getNewPaginationLayout', 'total, sizes, prev, pager, next, jumper');
          this.$store.dispatch('getNewElColNum', 15);
          this.$store.dispatch('getNewDialogMaxWidth', '80%');
          this.$store.dispatch('getNewSetLabelWidth', '300px');
        }
      },
      handleSelect(index) {
        this.activeIndex = index;
        if (this.windowWidth <= 750) {
          this.isCollapse = true;
          this.markSHow = false;
        }
      },
      copyLInk() {
        var clipboard = new Clipboard('#copyLInk');
        clipboard.on('success', e => {
          clipboard.destroy();
          this.$message.success('复制成功')
        });
        clipboard.on('error', e => {
          // 不支持复制
          console.log('该浏览器不支持自动复制');
          // 释放内存
          clipboard.destroy()
        })
      },
      // 侧边开关
      isCollapses() {
        this.isCollapse = !this.isCollapse;
        if (this.windowWidth <= 750) {
          this.markSHow = !this.isCollapse;
        }
      },
      handleCommand(command) {
        // 退出登录
        if (command == 'c') {
          this.$axios.post('mch/logout').then((res) => {
            sessionStorage.clear();
            this.$router.push('/');
            return
          });
        }
        if (command == 'a') {
          this.dialogVisibleuser = true;
          return
        }
        if (command === 'b') {
          this.dialogVisiblepas = true;
          return;
        }
      },
      getUserInfo() {
        this.$axios.post('mch/user_info').then((res) => {
          this.homeform = res.data;
          if (this.homeform.type === 1) {
            this.menuList = [
              {
                name: "控制台",
                path: "welcome",
                children: [],
                icon: 'el-icon-s-home',
              },
              {
                name: "数据统计",
                path: "",
                icon: 'el-icon-s-platform',
                children: [
                  {
                    name: "订单统计",
                    path: "statistical_order",
                    icon: '',
                  },
                  {
                    name: "用户统计",
                    path: "statistical_user",
                    icon: '',
                  },
                  {
                    name: "分成统计",
                    path: "statistical_into",
                    icon: '',
                  },
                ]
              },
              {
                name: "推广管理",
                path: "user",
                children: [
                  {
                    name: "小说推广",
                    path: "novel_extension",
                    icon: '',
                  },
                  {
                    name: "推广链接",
                    path: "novel_extensionLink",
                    icon: '',
                  },],
                icon: 'el-icon-phone',
              },
              {
                name: "代理商管理",
                path: "",
                icon: 'el-icon-s-opportunity',
                children: [{
                  name: "代理商列表",
                  path: "agentList",
                }, {
                  name: '代理商订单',
                  path: "agentOrder"
                }],
              },
              {
                name: "粉丝管理",
                path: "user",
                children: [],
                icon: 'el-icon-s-custom',
              },
              {
                name: "财务统计",
                path: "",
                icon: 'el-icon-s-marketing',
                children: [
                  {
                    name: "充值记录",
                    path: "financial_top",
                    icon: '',
                  },
                  {
                    name: '结算记录',
                    path: "financial_withdraw",
                  }
                ]
              }, {
                name: "系统设置",
                path: "",
                icon: 'el-icon-s-tools',
                children: [
                  {
                    name: "公众号配置",
                    path: "wx_set",
                  },
                  {
                    name: '防封域名配置',
                    path: "domain_name",
                  }
                ]
              }
            ];
          } else if (this.homeform.type === 2) {
            this.menuList = [
              {
                name: "控制台",
                path: "welcome",
                children: [],
                icon: 'el-icon-s-home',
              },
              {
                name: "数据统计",
                path: "",
                icon: 'el-icon-s-platform',
                children: [
                  {
                    name: "订单统计",
                    path: "statistical_order",
                    icon: '',
                  },
                  {
                    name: "用户统计",
                    path: "statistical_user",
                    icon: '',
                  },
                  {
                    name: "分成统计",
                    path: "statistical_into",
                    icon: '',
                  },
                ]
              },
              {
                name: "推广管理",
                path: "user",
                children: [
                  {
                    name: "小说推广",
                    path: "novel_extension",
                    icon: '',
                  },
                  {
                    name: "推广链接",
                    path: "novel_extensionLink",
                    icon: '',
                  },],
                icon: 'el-icon-phone',
              },
              {
                name: "粉丝管理",
                path: "user",
                children: [],
                icon: 'el-icon-s-custom',
              },
              {
                name: "财务统计",
                path: "",
                icon: 'el-icon-s-marketing',
                children: [
                  {
                    name: "充值记录",
                    path: "financial_top",
                    icon: '',
                  },
                  {
                    name: '结算记录',
                    path: "financial_withdraw",
                  }
                ]
              }, {
                name: "系统设置",
                path: "",
                icon: 'el-icon-s-tools',
                children: [
                  {
                    name: "公众号配置",
                    path: "wx_set",
                  },
                  {
                    name: '防封域名配置',
                    path: "domain_name",
                  }
                ]
              }
            ];
          }
        });
      },
      updatePas() {
        this.$axios.post('mch/personal/reset_password', this.pasform).then((res) => {
          this.$message('成功');
          this.dialogVisiblepas = false;
          this.$router.push('/');
        });
      },
      getWebName() {
        this.$axios.post('mch/common/getSiteName').then((res) => {
          this.$store.dispatch('getNewName', res.message)
        });
      },
    },

  }
</script>
<style scoped>
    @media screen and (max-width: 750px) {
        .el-aside {
            background-color: #3d4e63;
            color: #333;
            transition: all .5s;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 999;
            height: 100%;
        }

        .mark {
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, .6);
            position: fixed;
            left: 0;
            top: 0;
            z-index: 998;
        }

        .el-aside::-webkit-scrollbar {
            display: none
        }
    }


    .logo-text {
        margin-left: 10px;
        color: #ffffff !important;
    }

    .d-block {
        color: #ffffff !important;
    }

    .margin-left {
        display: none;
    }

    .home-logo .el-menu-item {
        padding: 0 20px !important;
    }

    .home-logo .el-menu-item:hover {
        background-color: #3f4d67 !important;
    }


    .isCollapse-icon {
        font-size: 30px;
        cursor: pointer;
        color: #606266;
        cursor: pointer;

    }


    .home-container {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100%;

    }

    .el-header {
        background: #f4f7fa;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .el-aside {
        background-color: #3d4e63;
        color: #333;
        transition: all .5s;
    }

    .el-aside::-webkit-scrollbar {
        display: none
    }

    .el-main {
        background-color: #E9EEF3;
        color: #333;
    }

    .el-menu {
        border: none;
    }


</style>